// extracted by mini-css-extract-plugin
export default {"wrapper":"Rating_wrapper__2jfcU","rating":"Rating_rating__4Yc6C","label":"Rating_label__v7bIM","error":"Rating_error__C3lAs"};